// The signed quote is shared by the browser, coordinator and immutable vault.
import { parseAbi } from 'viem';

export const VAULT_ABI = parseAbi([
  'function token() view returns (address)',
  'function signer() view returns (address)',
  'function paused() view returns (bool)',
  'function maxPayout() view returns (uint256)',
  'function dailyPayoutLimit() view returns (uint256)',
  'function states(bytes32) view returns (uint8)',
  'function digests(bytes32) view returns (bytes32)',
  'function execute((bytes32 id,address account,uint256 tokenAmount,uint256 creditMicro,uint8 direction,uint256 deadline) quote,bytes signature)',
  'function cancel((bytes32 id,address account,uint256 tokenAmount,uint256 creditMicro,uint8 direction,uint256 deadline) quote,bytes signature)',
  'event Executed(bytes32 indexed id,address indexed account,uint8 direction,uint256 tokenAmount,uint256 creditMicro)',
  'event Cancelled(bytes32 indexed id,address indexed account)',
]);
export const TOKEN_ABI = parseAbi([
  'function name() view returns (string)', 'function symbol() view returns (string)',
  'function decimals() view returns (uint8)', 'function totalSupply() view returns (uint256)',
  'function balanceOf(address) view returns (uint256)', 'function allowance(address,address) view returns (uint256)',
  'function approve(address,uint256) returns (bool)', 'function transfer(address,uint256) returns (bool)',
]);
export const QUOTE_TYPES = { Quote: [
  {name:'id',type:'bytes32'},{name:'account',type:'address'},
  {name:'tokenAmount',type:'uint256'},{name:'creditMicro',type:'uint256'},
  {name:'direction',type:'uint8'},{name:'deadline',type:'uint256'},
] } as const;
export const quoteDomain = (chainId: number, vault: `0x${string}`) => ({name:'kumioOS Convert',version:'1',chainId,verifyingContract:vault});
export interface SignedConversion {
  id: string; direction: 'token_to_credits' | 'credits_to_token';
  account: string; chainId: number; token: string; vault: string;
  tokenRaw: string; tokenAmount: string; creditsMicro: string; grossCreditsMicro: string;
  feeCreditsMicro: string; feeBps: number; rate: string; rateSource: 'operator';
  state: 'quoted' | 'pending' | 'completed' | 'cancelled' | 'expired';
  deadline: number; createdAt: number; settledAt: number | null;
  signature: string | null; txHash: string | null; submittedHash: string | null;
  error: string | null;
}
export interface ConversionStatus {
  enabled: boolean; ready: boolean; reason: string; sampledAt: number;
  rate: string | null; rateSource: 'operator'; rateExpiresAt: number | null;
  feeBps: number; minCredits: string; maxCredits: string | null;
  vault: string | null; reserveTokens: string | null; committedTokens: string | null;
  availableTokens: string | null; tokenDecimals: number | null;
  dailyPayoutTokens: string | null; payoutCommittedTodayTokens: string | null;
  finality: 'finalized'; oldCreditsEligible: true; newCreditsEligible: true;
}
export interface TokenInfo {
  configured: boolean; name: string | null; symbol: string | null; decimals: number | null;
  totalSupply: string | null; balance: string | null; balanceAddress: string | null;
  checkedAt: number; error: string | null;
}
